import useStrings from "./useStrings";
import Helpers from "../commons/helpers";
import InvitationService, { ICreateInvitation } from "../services/identity/invitation.service";
import { useCommonComponentContext } from "../providers/CommonComponentProvider";

const useContainerInvitation = () => {
    const Strings = useStrings();

    const {
        onError,
        onSuccess,
        onShowLoading,
        onHideLoading,
    } = useCommonComponentContext();

    const onResendInvitation = (props: { id: string, onCallBack?: () => void }) => {
        Helpers.showConfirmAlert(
            Strings.Staff.CONFIRM_RESEND,
            async () => {
                try {
                    onShowLoading();

                    await InvitationService.resend(props.id);

                    onSuccess(Strings.Staff.RESEND_SUCCESS);

                    props.onCallBack && props.onCallBack();
                } catch (error) {
                    const e = Helpers.renderExceptionError(error);
                    onError(e);
                } finally {
                    onHideLoading();
                }
            });
    };

    const onCreateInvitation = async (props: {
        data: ICreateInvitation,
        onCallBack?: () => void,
        newDomain?: string,
    }) => {
        try {
            onShowLoading();

            await InvitationService.create({
                data: { ...props.data },
                newDomain: props.newDomain,
            });

            onSuccess(Strings.Staff.SEND_SUCCESS);

            props.onCallBack && props.onCallBack();
        } catch (error) {
            const e = Helpers.renderExceptionError(error);
            onError(e);
        } finally {
            onHideLoading();
        }
    };

    const onDeleteInvitation = async (props: {
        id: string,
        onCallBack?: () => void,
    }) => {
        Helpers.showConfirmAlert(Strings.INVITATION.CONFIRM_DELETE,
            async () => {
                try {
                    onShowLoading();

                    await InvitationService.delete(props.id);

                    onSuccess(Strings.INVITATION.DELETE_INVITATION_SUCCESS);

                    props.onCallBack && props.onCallBack();
                } catch (error) {
                    const e = Helpers.renderExceptionError(error);
                    onError(e);
                } finally {
                    onHideLoading();
                }
            }
        );
    };

    const handlAcceptInvitation = (props: {
        id: string,
        onCallBack?: () => void,
    }) => {
        Helpers.showConfirmAlert(Strings.INVITATION.CONFIRM_ACCEPT,
            async () => {
                try {
                    onShowLoading();

                    await InvitationService.accept(props.id);

                    onSuccess(Strings.INVITATION.ACCEPT_SUCCESS);

                    props.onCallBack && props.onCallBack();

                } catch (error) {
                    const e = Helpers.renderExceptionError(error);
                    onError(e);
                } finally {
                    onHideLoading();
                }
            }
        );
    };

    const handlDeclineInvitation = (props: {
        id: string,
        onCallBack?: () => void,
    }) => {
        Helpers.showConfirmAlert(Strings.INVITATION.CONFIRM_DECLINE,
            async () => {
                try {
                    onShowLoading();

                    await InvitationService.decline(props.id);

                    onSuccess(Strings.INVITATION.DECLINE_SUCCESS);

                    props.onCallBack && props.onCallBack();
                } catch (error) {
                    const e = Helpers.renderExceptionError(error);
                    onError(e);
                } finally {
                    onHideLoading();
                }
            }
        );
    };

    return {
        onCreateInvitation,
        onResendInvitation,
        onDeleteInvitation,
        handlAcceptInvitation,
        handlDeclineInvitation,
    };
}

export default useContainerInvitation;